import { gql } from '@apollo/client';

/** All email templates (for admin edit context). */
export const getEmailTemplates = gql`query getEmailTemplates {
  getEmailTemplates {
    id
    type
    subject
    previewText
    bodyHtml
  }
}
`;

/** List email templates with search and pagination. */
export const getEmailTemplatesList = gql`query getEmailTemplatesList($searchKey: String, $currentPage: Int) {
  getEmailTemplatesList(searchKey: $searchKey, currentPage: $currentPage) {
    results {
      id
      type
      subject
      previewText
      bodyHtml
    }
    count
  }
}
`;

/** Email logo asset (used in template preview). */
export const getEmailLogo = gql`query getEmailLogo {
  getEmailLogo {
    id
    title
    name
    value
    type
  }
}
`;

export const getEmailTemplate = `query getEmailTemplate($type: String) {
  getEmailTemplate(type: $type) {
    subject
    previewText
    bodyHtml
  }
}
`;
